module.exports = __webpack_public_path__ + "img/loisir7.d1e6e429.jpg";